import React, { useState, useRef, useEffect } from "react";
import axios from "axios";

import { ToastContainer, toast } from "react-toastify";

import { BASE_URL, BASE_URL_PREBID } from "../../config/axios";
import Dashboardnavbar from '../../layout/Dashboardnavbar';
import Loader from "../Loader";
import { formatBasic } from "../custom";
import LineChart from "./LineChart";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { DownloadIcon } from "../AllSvg"

// import FinancialGraph from "./FinancialGraph";
// import TicketChatboxModal from "./ChatBox"



const MonthlyBasis = ({ onChange, value }) => {

    const [buffer, setBuffering] = useState(false);
    const [dataList, setDataList] = useState([]);
    const [filter, setFilter] = useState("monthlybasis");
    const [graph, showGraph] = useState("0");


    const downloadExcel = () => {
        if (!dataList.length) return;

        const worksheet = XLSX.utils.json_to_sheet(dataList);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Monthly Report");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(data, `Monthly_Billing_Report_${start}_to_${end}.xlsx`);
    };


    const [chartData, setChartData] = useState({
        months: [],
        gst: [],
        totalAmount: [],
        paymentReceived: [],
        pendingPayment: [],
    });

    const [expanded, setExpanded] = useState(true);

    const toggleExpand = () => {
        setExpanded(prev => !prev);
    };

    const [start, setStart] = useState('2025-01');
    const [end, setEnd] = useState('2025-05');

    const formatDate = (dateStr) => {
        const [year, month] = dateStr.split('-');
        return `${year}-${month}`;
    };

    function getYear(dateStr) {
        return dateStr.split('-')[0];
    }

    function getMonth(dateStr) {
        return parseInt(dateStr.split('-')[1], 10);
    }

    const getPaymentDetails = async () => {
        setBuffering(true);
        try {
            const invoice = await axios.get(`${BASE_URL_PREBID}/project/BillingReport-monthlybases/${getMonth(start)}/${getYear(start)}/${getMonth(end)}/${getYear(end)}/`);
            setDataList(invoice.data);
            const months = invoice.data.map(item => item.month);
            const gst = invoice.data.map(item => item.gst);
            const totalAmount = invoice.data.map(item => item.total_amount);
            const paymentReceived = invoice.data.map(item => item.payment_received);
            const pendingPayment = invoice.data.map(item => item.pending_payment);
            setChartData((prev) => ({ ...prev, months, gst, totalAmount, paymentReceived, pendingPayment }));
        } catch (err) {
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {

        getPaymentDetails();
    }, [start, end]);

    console.log({ dataList });

    return (
        <>

            <div className="table-css-white-background">

                <div className="table-heading-flex">
                    <div className="repo-heading font-weight500 font-size-heading">
                        Monthly Basis
                    </div>
                    <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '15px' }}>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'start' }}>
                            <label style={{ fontSize: '12px', color: '#333' }}>Excel Download:</label>
                            <button
                                onClick={downloadExcel}
                                style={{
                                    backgroundColor: '#2576bc',
                                    color: '#fff',
                                    padding: '4px 10px',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                                title="Download Excel"
                            >
                                <DownloadIcon />
                            </button>
                        </div>


                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            <label style={{ fontSize: '12px' }}>Start Date:</label>
                            <input
                                type="month"
                                value={start}
                                onChange={(e) => setStart(formatDate(e.target.value))}
                                style={{ backgroundColor: '#f6f7f9', border: 'none', outline: 'none', fontSize: '14px', padding: '4px', borderRadius: '4px' }}
                            />
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', }}>
                            <label style={{ fontSize: '12px' }}>End Date:</label>
                            <input
                                type="month"
                                value={end}
                                onChange={(e) => setEnd(formatDate(e.target.value))}
                                style={{ backgroundColor: '#f6f7f9', border: 'none', outline: 'none', fontSize: '14px', padding: '4px', borderRadius: '4px' }}
                            />
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            <label style={{ fontSize: '12px' }}>Filter</label>
                            <select
                                onChange={(e) => onChange(e.target.value)}
                                style={{ width: "9vw", backgroundColor: '#f6f7f9', border: 'none', outline: 'none', fontSize: '14px', padding: '4px', borderRadius: '4px' }}
                                value={value}
                            >
                                <option value="1">Monthly Basis</option>
                                <option value="2">Project Basis</option>
                                <option value="3">Client Basis</option>
                                <option value="4">Invoice Basis</option>
                            </select>
                        </div>
                    </div>
                </div>

                {/* {graph === "false" ?
                    <table className={`table-css ${buffer ? "height-73vh" : ''}`} >

                        <thead>
                            <tr className="custom-table-head-tr">
                                <th className="table-heading">Sr no.</th>
                                <th className="table-heading">Month-Year</th>

                                <th className="table-heading align-right">Basic</th>
                                <th className="table-heading align-right">GST</th>
                                <th className="table-heading align-right">IGST</th>
                                <th className="table-heading align-right">SGST</th>
                                <th className="table-heading align-right">CGST</th>
                                <th className="table-heading align-right">Total Amount</th>
                                <th className="table-heading align-right">Payment Received</th>
                                <th className="table-heading align-right">TDS</th>
                                <th className="table-heading align-right">Pending Payment</th>




                            </tr>
                        </thead>
                        {buffer ? <Loader /> : //buffering logic
                            <tbody >
                                {dataList
                                    .map((i, index) => (
                                        <React.Fragment key={index}>
                                            <tr className="tr-border-bottom">
                                                <td colSpan="11"></td>
                                            </tr>
                                            <tr className="custom-table-head-td">
                                                <td className="">{index + 1}</td>

                                                <td className="" style={{ textTransform: "capitalize" }}>{i.month}</td>

                                                <td className="align-right">{formatCurrencyIndian(i.basic)}</td>
                                                <td className="align-right">{formatCurrencyIndian(i.gst)}</td>

                                                <td className="align-right">{formatCurrencyIndian(i.igst)}</td>
                                                <td className="align-right">{formatCurrencyIndian(i.sgst)}</td>
                                                <td className="align-right">{formatCurrencyIndian(i.cgst)}</td>
                                                <td className="align-right">{formatCurrencyIndian(i.total_amount)}</td>
                                                <td className="align-right">{formatCurrencyIndian(i.payment_received)}</td>
                                                <td className="align-right">{formatCurrencyIndian(i.tds)}</td>
                                                <td className="align-right">{formatCurrencyIndian(i.pending_payment)}</td>












                                            </tr>
                                        </React.Fragment>
                                    ))}
                            </tbody>



                        }
                    </table> : null} */}
                {/* <FinancialGraph data={dataList} /> */}
                <div style={{ flex: 1, display: 'flex', alignItems: 'center', boxSizing: 'border-box', padding: '0px 4px', marginBottom: '16px', color: '#2576bc' }}><label style={{ fontSize: '18px', fontWeight: 500 }}>Financial Stats</label> <label onClick={toggleExpand} style={{ marginLeft: 'auto', fontSize: '14px', fontWeight: 500, cursor: 'pointer' }}>{expanded ? 'Collpase' : 'Expand'}</label></div>
                <div style={{
                    flex: 1, boxSizing: 'border-box', padding: expanded ? '8px' : '0px', backgroundColor: '#fff', border: expanded ? '1px solid #f6f7f9' : 'none', borderRadius: '8px', overflow: 'hidden', transition: 'max-height 0.3s ease',
                    maxHeight: expanded ? '1000px' : '0px'
                }}>
                    <LineChart data={chartData} />
                </div>
                <div>
                    <div className="global-table-cont scroll-container-table no-max-height'" style={{ minHeight: "450px" }}>
                        <table className={`table-css ${buffer ? "height-73vh" : ''}`} >

                            <thead>
                                <tr className="custom-table-head-tr">
                                    <th className="table-heading">Sr no.</th>
                                    <th className="table-heading">Month-Year</th>

                                    <th className="table-heading align-right">Basic</th>
                                    <th className="table-heading align-right">GST</th>
                                    <th className="table-heading align-right">IGST</th>
                                    <th className="table-heading align-right">SGST</th>
                                    <th className="table-heading align-right">CGST</th>
                                    <th className="table-heading align-right">Total Amount</th>
                                    <th className="table-heading align-right">Payment Received</th>
                                    <th className="table-heading align-right">TDS</th>
                                    <th className="table-heading align-right">Pending Payment</th>




                                </tr>
                            </thead>


                            {buffer ? <Loader /> : //buffering logic
                                <tbody >
                                    {dataList
                                        .map((i, index) => (
                                            <React.Fragment key={index}>
                                                <tr className="tr-border-bottom">
                                                    <td colSpan="11"></td>
                                                </tr>
                                                <tr className="custom-table-head-td">
                                                    <td className="">{index + 1}</td>

                                                    <td className="" style={{ textTransform: "capitalize" }}>{i.month}</td>

                                                    <td className="align-right">{formatBasic(i.basic)}</td>
                                                    <td className="align-right">{formatBasic(i.gst)}</td>

                                                    <td className="align-right">{formatBasic(i.igst)}</td>
                                                    <td className="align-right">{formatBasic(i.sgst)}</td>
                                                    <td className="align-right">{formatBasic(i.cgst)}</td>
                                                    <td className="align-right">{formatBasic(i.total_amount)}</td>
                                                    <td className="align-right">{formatBasic(i.payment_received)}</td>
                                                    <td className="align-right">{formatBasic(i.tds)}</td>
                                                    <td className={`align-right ${i.pending_payment < 0 ? 'red-text' : 'green-text'}`}>{formatBasic(i.pending_payment)}</td>












                                                </tr>
                                            </React.Fragment>
                                        ))}
                                    <React.Fragment>
                                        <tr className="tr-border-bottom">
                                            <td colSpan="11"></td>
                                        </tr>
                                        <tr className="custom-table-head-td">
                                            <td className="">Total</td>

                                            <td className=""></td>

                                            <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.basic, 0))}</td>

                                            <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.gst, 0))}</td>
                                            <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.igst, 0))}</td>
                                            <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.sgst, 0))}</td>
                                            <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.cgst, 0))}</td>
                                            <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.total_amount, 0))}</td>
                                            <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.payment_received, 0))}</td>
                                            <td className={`align-right`}>{formatBasic(dataList.reduce((sum, item) => sum + item.tds, 0))}</td>
                                            <td className={`align-right ${dataList.reduce((sum, item) => sum + item.pending_payment, 0) < 0 ? 'red-text' : 'green-text'}`}>{formatBasic(dataList.reduce((sum, item) => sum + item.pending_payment, 0))}</td>
                                        </tr>
                                    </React.Fragment>
                                </tbody>



                            }
                        </table>
                    </div>

                </div>

            </div>

        </>
    );
};

const ProjectBasis = ({ onChange, value }) => {

    const [buffer, setBuffering] = useState(false);
    const [dataList, setDataList] = useState([]);

    useEffect(() => {

        getPaymentDetails();
    }, []);

    function getYear(dateStr) {
        return dateStr.split('-')[0];
    }

    function getMonth(dateStr) {
        return parseInt(dateStr.split('-')[1], 10);
    }

    const getPaymentDetails = async () => {
        setBuffering(true);
        try {
            const invoice = await axios.get(`${BASE_URL_PREBID}/project/BillingReport-projectbases/${getMonth(start)}/${getYear(start)}/${getMonth(end)}/${getYear(end)}/`);
            setDataList(invoice.data);



        } catch (err) {
        } finally {
            setBuffering(false);
        }
    };


    const [start, setStart] = useState('2025-01');
    const [end, setEnd] = useState('2025-05');
    const formatDate = (dateStr) => {
        const [year, month] = dateStr.split('-');
        return `${year}-${month}`;
    };

    useEffect(() => {

        getPaymentDetails();
    }, [start, end]);

    const downloadExcel = () => {
        if (!dataList.length) return;

        const worksheet = XLSX.utils.json_to_sheet(dataList);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Monthly Report");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(data, `Project_Basis_Report_${start}_to_${end}.xlsx`);
    };

    return (
        <>

            <div className="table-css-white-background">


                <div className="table-heading-flex">
                    <div className="repo-heading font-weight500 font-size-heading">
                        Project Basis
                    </div>
                    <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'start', gap: '15px' }}>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'start' }}>
                            <label style={{ fontSize: '12px', color: '#333' }}>Excel Download:</label>
                            <button
                                onClick={downloadExcel}
                                style={{
                                    backgroundColor: '#2576bc',
                                    color: '#fff',
                                    padding: '4px 10px',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                                title="Download Excel"
                            >
                                <DownloadIcon />
                            </button>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            <label style={{ fontSize: '12px' }}>Start Date:</label>
                            <input
                                type="month"
                                value={start}
                                onChange={(e) => setStart(formatDate(e.target.value))}
                                style={{ backgroundColor: '#f6f7f9', border: 'none', outline: 'none', fontSize: '14px', padding: '4px', borderRadius: '4px' }}
                            />
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '40px' }}>
                            <label style={{ fontSize: '12px' }}>End Date:</label>
                            <input
                                type="month"
                                value={end}
                                onChange={(e) => setEnd(formatDate(e.target.value))}
                                style={{ backgroundColor: '#f6f7f9', border: 'none', outline: 'none', fontSize: '14px', padding: '4px', borderRadius: '4px' }}
                            />
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            <label style={{ fontSize: '12px' }}>Filter</label>
                            <select
                                onChange={(e) => onChange(e.target.value)}
                                style={{ width: "9vw", backgroundColor: '#f6f7f9', border: 'none', outline: 'none', fontSize: '14px', padding: '4px', borderRadius: '4px' }}
                                value={value}
                            >
                                <option value="1">Monthly Basis</option>
                                <option value="2">Project Basis</option>
                                <option value="3">Client Basis</option>
                                <option value="4">Invoice Basis</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="global-table-cont scroll-container-table no-max-height" style={{ minHeight: "73vh" }}>
                    <table className={`table-css custom-table  custom-tables ${buffer ? "height-73vh" : ''}`} >

                        <thead className="custom-table">
                            <tr className="custom-table-head-tr">
                                <th className="table-heading">Sr no.</th>
                                <th className="table-heading">Project Code</th>
                                <th className="table-heading">Project Short Name</th>
                                <th className="table-heading align-right">Client Count</th>
                                <th className="table-heading align-right">Basic</th>
                                <th className="table-heading align-right">GST</th>
                                <th className="table-heading align-right">IGST</th>
                                <th className="table-heading align-right">SGST</th>
                                <th className="table-heading align-right">CGST</th>
                                <th className="table-heading align-right">Total Amount</th>
                                <th className="table-heading align-right">Payment Received</th>
                                <th className="table-heading align-right">TDS</th>
                                <th className="table-heading align-right">Pending Payment</th>
                            </tr>
                        </thead>
                        {buffer ? <Loader /> : //buffering logic
                            <tbody >
                                {dataList
                                    .map((i, index) => (
                                        <React.Fragment key={index}>
                                            <tr className="tr-border-bottom">
                                                <td colSpan="11"></td>
                                            </tr>
                                            <tr className="custom-table-head-td">
                                                <td className="">{index + 1}</td>

                                                <td className="" style={{ textTransform: "capitalize" }}>{i.project_code}</td>

                                                <td className="" style={{ textTransform: "capitalize" }}>{i.project_short_name}{i.pr_project && <span className="green-text"> (PR)</span>}</td>
                                                <td className="align-right">{formatBasic(i.client_project_count)}</td>
                                                <td className="align-right">{formatBasic(i.basic)}</td>
                                                <td className="align-right">{formatBasic(i.gst)}</td>

                                                <td className="align-right">{formatBasic(i.igst)}</td>
                                                <td className="align-right">{formatBasic(i.sgst)}</td>
                                                <td className="align-right">{formatBasic(i.cgst)}</td>
                                                <td className="align-right">{formatBasic(i.total_amount)}</td>
                                                <td className="align-right">{formatBasic(i.payment_received)}</td>
                                                <td className="align-right">{formatBasic(i.tds)}</td>
                                                <td className={`align-right ${i.pending_payment < 0 ? 'red-text' : 'green-text'}`}>{formatBasic(i.pending_payment)}</td>

                                            </tr>
                                        </React.Fragment>
                                    ))}
                                <React.Fragment>
                                    <tr className="tr-border-bottom">
                                        <td colSpan="11"></td>
                                    </tr>
                                    <tr className="custom-table-head-td">
                                        <td className="">Total</td>

                                        <td className=""></td>
                                        <td className=""></td>
                                        <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.basic, 0))}</td>

                                        <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.gst, 0))}</td>
                                        <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.igst, 0))}</td>
                                        <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.sgst, 0))}</td>
                                        <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.cgst, 0))}</td>
                                        <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.total_amount, 0))}</td>
                                        <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.payment_received, 0))}</td>
                                        <td className={`align-right`}>{formatBasic(dataList.reduce((sum, item) => sum + item.tds, 0))}</td>
                                        <td className={`align-right ${dataList.reduce((sum, item) => sum + item.pending_payment, 0) < 0 ? 'red-text' : 'green-text'}`}>{formatBasic(dataList.reduce((sum, item) => sum + item.pending_payment, 0))}</td>
                                    </tr>
                                </React.Fragment>

                            </tbody>



                        }
                    </table>
                </div>




            </div>

        </>
    );
};

const ClientBasis = ({ onChange, value }) => {

    const [buffer, setBuffering] = useState(false);
    const [dataList, setDataList] = useState([]);

    useEffect(() => {

        getPaymentDetails();
    }, []);

    const getPaymentDetails = async () => {
        setBuffering(true);
        try {
            const invoice = await axios.get(`${BASE_URL_PREBID}/project/BillingReport-clientbases/`);
            setDataList(invoice.data);



        } catch (err) {
        } finally {
            setBuffering(false);
        }
    };

    const downloadExcel = () => {
        if (!dataList.length) return;

        const worksheet = XLSX.utils.json_to_sheet(dataList);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Monthly Report");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(data, `Client_Basis_Report_.xlsx`);
    };


    return (
        <>

            <div className="table-css-white-background">

                <div className="table-heading-flex">
                    <div className="repo-heading font-weight500 font-size-heading">
                        Client Basis
                    </div>
                    <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'start', gap: '15px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'start' }}>
                            <label style={{ fontSize: '12px', color: '#333' }}>Excel Download:</label>
                            <button
                                onClick={downloadExcel}
                                style={{
                                    backgroundColor: '#2576bc',
                                    color: '#fff',
                                    padding: '4px 10px',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                                title="Download Excel"
                            >
                                <DownloadIcon />
                            </button>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            <label style={{ fontSize: '12px' }}>Filter</label>
                            <select
                                onChange={(e) => onChange(e.target.value)}
                                style={{ width: "9vw", backgroundColor: '#f6f7f9', border: 'none', outline: 'none', fontSize: '14px', padding: '4px', borderRadius: '4px' }}
                                value={value}
                            >
                                <option value="1">Monthly Basis</option>
                                <option value="2">Project Basis</option>
                                <option value="3">Client Basis</option>
                                <option value="4">Invoice Basis</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div className="global-table-cont scroll-container-table no-max-height" style={{ minHeight: "73vh" }}>
                    <table className={`table-css custom-table  custom-tables ${buffer ? "height-73vh" : ''}`} >

                        <thead className="custom-table">
                            <tr className="custom-table-head-tr">
                                <th className="table-heading">Sr no.</th>
                                <th className="table-heading">Client Name</th>

                                <th className="table-heading align-right">Basic</th>
                                <th className="table-heading align-right">GST</th>
                                <th className="table-heading align-right">IGST</th>
                                <th className="table-heading align-right">SGST</th>
                                <th className="table-heading align-right">CGST</th>
                                <th className="table-heading align-right">Total Amount</th>
                                <th className="table-heading align-right">Payment Received</th>
                                <th className="table-heading align-right">TDS</th>
                                <th className="table-heading align-right">Pending Payment</th>




                            </tr>
                        </thead>
                        {buffer ? <Loader /> : //buffering logic
                            <tbody >
                                {dataList
                                    .map((i, index) => (
                                        <React.Fragment key={index}>
                                            <tr className="tr-border-bottom">
                                                <td colSpan="11"></td>
                                            </tr>
                                            <tr className="custom-table-head-td">
                                                <td className="">{index + 1}</td>

                                                <td className="" >{i.client_name}{i.pr_client && <span className="green-text"> (PR)</span>}</td>

                                                <td className="align-right">{formatBasic(i.basic)}</td>
                                                <td className="align-right">{formatBasic(i.gst)}</td>

                                                <td className="align-right">{formatBasic(i.igst)}</td>
                                                <td className="align-right">{formatBasic(i.sgst)}</td>
                                                <td className="align-right">{formatBasic(i.cgst)}</td>
                                                <td className="align-right">{formatBasic(i.total_amount)}</td>
                                                <td className="align-right">{formatBasic(i.payment_received)}</td>
                                                <td className="align-right">{formatBasic(i.tds)}</td>
                                                <td className={`align-right ${i.pending_payment < 0 ? 'red-text' : 'green-text'}`}>{formatBasic(i.pending_payment)}</td>












                                            </tr>
                                        </React.Fragment>
                                    ))}
                                <React.Fragment>
                                    <tr className="tr-border-bottom">
                                        <td colSpan="11"></td>
                                    </tr>
                                    <tr className="custom-table-head-td">
                                        <td className="">Total</td>

                                        <td className=""></td>

                                        <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.basic, 0))}</td>

                                        <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.gst, 0))}</td>
                                        <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.igst, 0))}</td>
                                        <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.sgst, 0))}</td>
                                        <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.cgst, 0))}</td>
                                        <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.total_amount, 0))}</td>
                                        <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.payment_received, 0))}</td>
                                        <td className={`align-right`}>{formatBasic(dataList.reduce((sum, item) => sum + item.tds, 0))}</td>
                                        <td className={`align-right ${dataList.reduce((sum, item) => sum + item.pending_payment, 0) < 0 ? 'red-text' : 'green-text'}`}>{formatBasic(dataList.reduce((sum, item) => sum + item.pending_payment, 0))}</td>
                                    </tr>
                                </React.Fragment>
                            </tbody>



                        }
                    </table>

                </div>

            </div>

        </>
    );
};

const InvoiceBasis = ({ onChange, value }) => {

    const [buffer, setBuffering] = useState(false);
    const [dataList, setDataList] = useState([]);

    useEffect(() => {

        getPaymentDetails();
    }, []);

    const getPaymentDetails = async () => {
        setBuffering(true);
        try {
            const invoice = await axios.get(`${BASE_URL_PREBID}/project/BillingReport-invoicebases/${getMonth(start)}/${getYear(start)}/${getMonth(end)}/${getYear(end)}/`);
            setDataList(invoice.data);



        } catch (err) {
        } finally {
            setBuffering(false);
        }
    };


    const [start, setStart] = useState('2025-01');
    const [end, setEnd] = useState('2025-05');

    const formatDate = (dateStr) => {
        const [year, month] = dateStr.split('-');
        return `${year}-${month}`;
    };

    function getYear(dateStr) {
        return dateStr.split('-')[0];
    }

    function getMonth(dateStr) {
        return parseInt(dateStr.split('-')[1], 10);
    }
    useEffect(() => {

        getPaymentDetails();
    }, [start, end]);

    const downloadExcel = () => {
        if (!dataList.length) return;

        const worksheet = XLSX.utils.json_to_sheet(dataList);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Monthly Report");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(data, `Invoice_Basis_Report_${start}_to_${end}.xlsx`);
    };
    return (
        <>

            <div className="table-css-white-background">

                <div className="table-heading-flex">
                    <div className="repo-heading font-weight500 font-size-heading">
                        Invoice Basis
                    </div>
                    <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'start', gap: '15px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'start' }}>
                            <label style={{ fontSize: '12px', color: '#333' }}>Excel Download:</label>
                            <button
                                onClick={downloadExcel}
                                style={{
                                    backgroundColor: '#2576bc',
                                    color: '#fff',
                                    padding: '4px 10px',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                                title="Download Excel"
                            >
                                <DownloadIcon />
                            </button>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            <label style={{ fontSize: '12px' }}>Start Date:</label>
                            <input
                                type="month"
                                value={start}
                                onChange={(e) => setStart(formatDate(e.target.value))}
                                style={{ backgroundColor: '#f6f7f9', border: 'none', outline: 'none', fontSize: '14px', padding: '4px', borderRadius: '4px' }}
                            />
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '40px' }}>
                            <label style={{ fontSize: '12px' }}>End Date:</label>
                            <input
                                type="month"
                                value={end}
                                onChange={(e) => setEnd(formatDate(e.target.value))}
                                style={{ backgroundColor: '#f6f7f9', border: 'none', outline: 'none', fontSize: '14px', padding: '4px', borderRadius: '4px' }}
                            />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            <label style={{ fontSize: '12px' }}>Filter</label>
                            <select
                                onChange={(e) => onChange(e.target.value)}
                                style={{ width: "9vw", backgroundColor: '#f6f7f9', border: 'none', outline: 'none', fontSize: '14px', padding: '4px', borderRadius: '4px' }}
                                value={value}
                            >
                                <option value="1">Monthly Basis</option>
                                <option value="2">Project Basis</option>
                                <option value="3">Client Basis</option>
                                <option value="4">Invoice Basis</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div className="global-table-cont scroll-container-table no-max-height" style={{ minHeight: "73vh" }}>

                    <table className={`table-css custom-table  custom-tables ${buffer ? "height-73vh" : ''}`} >

                        <thead className="custom-table">
                            <tr className="custom-table-head-tr">
                                <th className="table-heading">Sr no.</th>
                                <th className="table-heading">Invoice Number</th>

                                <th className="table-heading align-right">Basic</th>
                                <th className="table-heading align-right">GST</th>
                                <th className="table-heading align-right">IGST</th>
                                <th className="table-heading align-right">SGST</th>
                                <th className="table-heading align-right">CGST</th>
                                <th className="table-heading align-right">Total Amount</th>
                                <th className="table-heading align-right">Payment Received</th>
                                <th className="table-heading align-right">TDS</th>
                                <th className="table-heading align-right">Pending Payment</th>




                            </tr>
                        </thead>
                        {buffer ? <Loader /> : //buffering logic
                            <tbody >
                                {dataList
                                    .map((i, index) => (
                                        <React.Fragment key={index}>
                                            <tr className="tr-border-bottom">
                                                <td colSpan="11"></td>
                                            </tr>
                                            <tr className="custom-table-head-td">
                                                <td className="">{index + 1}</td>

                                                <td className="" >{i.invoice_number}</td>

                                                <td className="align-right">{formatBasic(i.basic)}</td>
                                                <td className="align-right">{formatBasic(i.gst)}</td>

                                                <td className="align-right">{formatBasic(i.igst)}</td>
                                                <td className="align-right">{formatBasic(i.sgst)}</td>
                                                <td className="align-right">{formatBasic(i.cgst)}</td>
                                                <td className="align-right">{formatBasic(i.total_amount)}</td>
                                                <td className="align-right">{formatBasic(i.payment_received)}</td>
                                                <td className="align-right">{formatBasic(i.tds)}</td>
                                                <td className={`align-right ${i.pending_payment < 0 ? 'red-text' : 'green-text'}`}>{formatBasic(i.pending_payment)}</td>












                                            </tr>
                                        </React.Fragment>
                                    ))}
                                <React.Fragment>
                                    <tr className="tr-border-bottom">
                                        <td colSpan="11"></td>
                                    </tr>
                                    <tr className="custom-table-head-td">
                                        <td className="">Total</td>

                                        <td className=""></td>

                                        <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.basic, 0))}</td>

                                        <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.gst, 0))}</td>
                                        <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.igst, 0))}</td>
                                        <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.sgst, 0))}</td>
                                        <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.cgst, 0))}</td>
                                        <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.total_amount, 0))}</td>
                                        <td className="align-right">{formatBasic(dataList.reduce((sum, item) => sum + item.payment_received, 0))}</td>
                                        <td className={`align-right`}>{formatBasic(dataList.reduce((sum, item) => sum + item.tds, 0))}</td>
                                        <td className={`align-right ${dataList.reduce((sum, item) => sum + item.pending_payment, 0) < 0 ? 'red-text' : 'green-text'}`}>{formatBasic(dataList.reduce((sum, item) => sum + item.pending_payment, 0))}</td>
                                    </tr>
                                </React.Fragment>
                            </tbody>



                        }
                    </table>

                </div>

            </div>

        </>
    );
};




export { MonthlyBasis, ProjectBasis, ClientBasis, InvoiceBasis }